import '@vaadin/grid';
import './descope-grid-text-column';
import './descope-grid-custom-column';
import './descope-grid-selection-column';
import './descope-grid-item-details-column';
import '../descope-code-snippet'; // this is needed for the details panel

import { componentName, GridClass } from './GridClass';

customElements.define(componentName, GridClass);

export { GridClass, componentName };
